import { render, staticRenderFns } from "./widgetCard.vue?vue&type=template&id=e7aa2a64&scoped=true"
import script from "./widgetCard.vue?vue&type=script&lang=js"
export * from "./widgetCard.vue?vue&type=script&lang=js"
import style0 from "./widgetCard.vue?vue&type=style&index=0&id=e7aa2a64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7aa2a64",
  null
  
)

export default component.exports